// extracted by mini-css-extract-plugin
export var base = "_2q-0";
export var updateBanner = "_2q-1";